// Image
import imageLight from "../../assets/images/bg-desktop-light.jpg";

export const lightTheme = {
  background: "#e4e5f1",
  listBackground: "#fafafa",
  title: "#fafafa",
  primary: "#484b6a",
  secondary: "#9394a5",
  tertiary: "#d2d3db",
  draggable: "#f9eefe",
  blue: "#3a7bfd",
  image: imageLight,
};
